/**
 * Enumeraciones de dominio. Son la fuente única de verdad: la API las usa para
 * definir los tipos enumerados de PostgreSQL y la web para filtros y etiquetas.
 */

export const USER_ROLES = ['ADMIN', 'OFFICE', 'OPERATOR'] as const;
export type UserRole = (typeof USER_ROLES)[number];

/**
 * Ciclo de vida del palet:
 * PENDING_LOCATION → STORED ⇄ RESERVED → EXITED
 * Cualquier estado previo a EXITED puede pasar a CANCELLED (entrada registrada por error).
 */
export const PALLET_STATUSES = [
  'PENDING_LOCATION',
  'STORED',
  'RESERVED',
  'EXITED',
  'CANCELLED',
] as const;
export type PalletStatus = (typeof PALLET_STATUSES)[number];

/** Estados en los que el palet está físicamente en las instalaciones. */
export const IN_STOCK_PALLET_STATUSES = [
  'PENDING_LOCATION',
  'STORED',
  'RESERVED',
] as const satisfies readonly PalletStatus[];

/** Estado operativo configurable de una ubicación. La ocupación se deriva de los palets. */
export const LOCATION_STATUSES = ['ACTIVE', 'OUT_OF_SERVICE'] as const;
export type LocationStatus = (typeof LOCATION_STATUSES)[number];

/** Estado visual de una ubicación en el mapa (derivado, no se almacena). */
export const LOCATION_DISPLAY_STATUSES = [
  'FREE',
  'OCCUPIED',
  'RESERVED',
  'OUT_OF_SERVICE',
] as const;
export type LocationDisplayStatus = (typeof LOCATION_DISPLAY_STATUSES)[number];

export const MOVEMENT_TYPES = ['PLACEMENT', 'RELOCATION', 'RELEASE'] as const;
export type MovementType = (typeof MOVEMENT_TYPES)[number];

export const OUTBOUND_ORDER_STATUSES = ['OPEN', 'COMPLETED', 'CANCELLED'] as const;
export type OutboundOrderStatus = (typeof OUTBOUND_ORDER_STATUSES)[number];

export const OUTBOUND_LINE_STATUSES = ['PENDING', 'PICKED', 'SHIPPED', 'REMOVED'] as const;
export type OutboundLineStatus = (typeof OUTBOUND_LINE_STATUSES)[number];

/** Líneas que mantienen el palet reservado. */
export const ACTIVE_OUTBOUND_LINE_STATUSES = [
  'PENDING',
  'PICKED',
] as const satisfies readonly OutboundLineStatus[];

export const INVOICE_STATUSES = ['DRAFT', 'ISSUED', 'PAID', 'CANCELLED'] as const;
export type InvoiceStatus = (typeof INVOICE_STATUSES)[number];

export const INVOICE_LINE_CONCEPTS = ['ENTRY', 'STORAGE', 'EXIT'] as const;
export type InvoiceLineConcept = (typeof INVOICE_LINE_CONCEPTS)[number];

/** Modos de cómputo de días facturables (la regla definitiva está pendiente de negocio). */
export const DAY_COUNTING_MODES = ['CALENDAR_DAYS', 'STARTED_24H_PERIODS'] as const;
export type DayCountingMode = (typeof DAY_COUNTING_MODES)[number];
